export const BROWSER_SESSION_BASED_LOADING_HOME: boolean = false;
export const ACCELERATED_LOADING: boolean = true;
export const LOADING_SPEED_FACTOR: number = 40;
